const en = {
  routeName: {
    home: 'Home',
    stores: 'Locations',
    QR: 'Generate QR code',
    transactionHistory: 'Transactions History',
    setting: 'Settings',
    adminManage: 'Admin management',
    logs: 'Coin conversion logs',
  },
  logOut: {
    label: 'Log out',
    confirmTitle: 'Log out confirmation',
    confirmMessage: 'Are you sure you want to logout?',
  },
  openStore: {
    confirmTitle: 'Online',
    confirmMessage:
      'Customers are able to visit registered stores for coins conversion based on chosen operation hours.',
  },
  closeStore: {
    confirmTitle: 'Going offline',
    confirmMessage:
      "Going offline means customer can't come to you for coin conversion. Please confirm that you want to go offline",
  },
  confirmActiveStore: {
    title: 'Active a location',
    message:
      'Location can login to the merchant website and coin conversion. Please confirm that you want to active a location',
  },
  confirmInactiveStore: {
    title: 'Deactivate a localtion',
    message:
      "Location can't login to the merchant website and coin conversion. Please confirm that you want to deactivate a location",
  },
  confirmTransferred: {
    title: 'Confirm coins received',
    message:
      'This will update the transaction status to DONE. Do you want to continue?',
  },

  address: 'Address',
  closed: 'Closed',
  code: 'Code',
  digit: 'Digit',
  email: 'Email',
  endTime: 'End time',
  goBack: 'Go back',
  language: 'Language',
  open: 'Open',
  password: 'Password',
  startTime: 'Start time',
  storeID: 'Location ID',
  storeEmail: 'Location email',
  storeName: 'Location Name',
  storePhone: 'Location telephone number',
  storeLogo: 'Location logo',
  selectFile: 'Select file',
  storeAddress: 'Location address',
  submit: 'Submit',
  save: 'Save',

  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',

  coinDeposit: 'COIN CONVERSION',
  status: 'STATUS',
  success: 'SUCCESS',
  transactionId: 'TRANSACTION ID',
  clientFullName: 'CUSTOMER FULL NAME',
  clientPhoneNumber: 'CUSTOMER MOBILE PHONE NUMBER',
  timeCreated: 'TIME CREATED',
  transactionFee: 'TRANSACTION FEE',
  back: 'BACK',
  depositAmount: 'Coin amount(RM)',
  amount: 'Amount(RM)',
  coinDepositAmount: 'Coin amount(RM)',
  confirmGenerateQrCode: (amount) =>
    `Converting coins to RM${amount}. Generate QR code?`,
  pleaseInputAmountRM:
    'Enter the value of coins the customer wants to deposit. Eg: RM10.20',
  generateQrCode: 'Generate QR code',
  expiresIn: 'Expires in',
  qrCodeExpired: 'QR code expired',
  regenerateQrCode: 'Regenerate QR code',
  changeAmount: 'Change amount',
  createTransactionSuccess: 'Transaction started',
  depositTimestamp: 'Conversion timestamp',

  id: 'ID',
  phoneNumber: 'Mobile phone number',
  customerName: 'Customer name',
  help: 'Help',
  requestHelp: 'Request help',
  timeAt: 'Time at',
  dateRange: 'Date range',
  updateSettingsSuccess: 'Settings updated',
  resendEmail: 'Resend email',
  emailVerifySent:
    'A 6-digit code has been sent to you via email. Enter it below',
  latitude: 'Latitude',
  longitude: 'Longitude',
  miniumAmountRequired: 'Minimum amount required',
  locationSetting: 'Location setting',
  needHelp: 'Need help?',
  tooltipFindLatitude: 'Find or enter latitude and longitude',
  createStore: 'Create location',
  editStore: 'Edit location',
  storeNotFound: 'Store not found',
  backToListStore: 'Back to location list',
  action: 'Action',
  transferred: 'Coins received',
  export: 'Export',
  transactionDetail: 'Transaction detail',
  sendTo: 'Send to',
  charity: 'Charity',
  bank: 'Bank',
  bankAccountName: 'Bank account holder name',
  bankAccountNumber: 'Bank account number',
  transactionStatus: 'Transaction status',
  bankName: 'Bank name',
  search: 'Search',
  resetFilter: 'Reset filter',
  login: 'Login',
  verifyEmail: 'Verify email address',
  changeOnlineHours: 'Edit operating hours',
  clickToAddTimeSlot: 'Click here to add another time slot for',
  clickHereToOnline: 'Click here to go online',
  offline: 'Offline',
  online: 'Online',
  active: 'Active',

  account: 'Account',
  changePassword: 'Change password',
  currentPassword: 'Current password',
  newPassword: 'New password',
  confirmNewPassword: 'Confirm new password',
  passwordNotMatch: 'New passwords do not match!',
  changePasswordSuccess: 'Password changed successfully',
  forgotPassword: 'Forgot password?',
  backToLogin: 'Back to log in',
  forgotPass: {
    emailSent: 'Check your email',
    message1: 'An email has been sent to',
    message2: 'Follow the directions in the email to reset your password',
    messageEnterMail:
      "Enter your email address. We'll send you a link to reset your password",
  },
  resetPassword: 'Reset password',
  continue: 'Continue',

  welcome: 'Welcome',
  messCreateYourPassword: 'Create your password so we can get it to work',
  createPasswordSuccess: 'Password created successfully',
  loginToStart: "Let's login to start your work",
  createPassword: 'Create password',
  createAdmin: 'Create admin',
  fullName: 'Full name',
  role: 'Role',
  admin: 'Admin',
  superAdmin: 'Super admin',
  createSuccess: 'Create successfully',
  sendInvitationEmail: 'Send invitation email',
  objSendInvitation: {
    title: 'Send invitation email to location',
    content: 'You will send an invitation email. Do you want to continue?',
    success: 'Email sent successfully',
    error1: 'Unable to send email to',
    btnReSend: 'Resend email',
    sendingEmail: 'Sending invitation email',
  },
  objExportError: {
    title: 'Data error',
    isDone: 'Transaction DONE',
    isMissingData: 'Missing data transaction',
    isConfirmed: 'Transaction CONFIRMED',
  },
  wantToContinue: 'Continue?',
  exportBulkPayment: 'Export for Bulk Payment',
  requestBody: 'Request Body',
  responseMessage: 'Response message',
  statusCode: 'Status code',
  api: 'API',
  createdAt: 'Created at',
  adminNotFound: 'Admin not found.',
  backToAdminManage: 'Back to Admin management',
  confirmInactiveAdmin: {
    title: 'Deactivate an admin account',
    message:
      'This account will be logged out from every device and will no longer be able to login again. Continue?',
  },
  confirmActiveAmin: {
    title: 'Activate an admin account',
    message: 'This account can login to this page. Continue?',
  },
  editAdmin: 'Edit admin',
  updateSuccess: 'Update successful',
  waitingTransfer: 'Waiting for transfer',
  coinReceived: 'Coin received',
  paid: 'Paid',
  requestHelpTitle: 'REQUEST HELP FOR THIS TRANSACTION',
  locationOperationHours: 'Coins Conversion Operating Hours',
};

export default en;
